import { render, staticRenderFns } from "./ReservationCommnet.vue?vue&type=template&id=b91488a8&scoped=true&"
import script from "./ReservationCommnet.vue?vue&type=script&lang=js&"
export * from "./ReservationCommnet.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCommnet.vue?vue&type=style&index=0&id=b91488a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91488a8",
  null
  
)

export default component.exports